var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_5558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10.6251H12.6673L14.6673 15.5834H1.33398L3.33398 10.6251H6.00065M8.66732 5.66675C8.66732 5.85461 8.59708 6.03478 8.47206 6.16762C8.34703 6.30045 8.17746 6.37508 8.00065 6.37508C7.82384 6.37508 7.65427 6.30045 7.52925 6.16762C7.40422 6.03478 7.33398 5.85461 7.33398 5.66675C7.33398 5.47889 7.40422 5.29872 7.52925 5.16588C7.65427 5.03304 7.82384 4.95841 8.00065 4.95841C8.17746 4.95841 8.34703 5.03304 8.47206 5.16588C8.59708 5.29872 8.66732 5.47889 8.66732 5.66675ZM4.00065 5.66675C4.00065 9.20841 8.00065 12.7501 8.00065 12.7501C8.00065 12.7501 12.0007 9.20841 12.0007 5.66675C12.0007 3.24637 10.21 1.41675 8.00065 1.41675C5.79132 1.41675 4.00065 3.24637 4.00065 5.66675Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_5558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.626231772da888d094eea3461aa475f1.svg";
export { ForwardRef as ReactComponent };